import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'power_multiplication_positive',
    dependencies: [
        'levels_maths/berengere_maths/power_one'
    ]
})



function commonMultiplyWithPower (q, base, pow) {
    q.addMathFormula(base + 'xx' + base + '^\\color{blue}[' + pow + ']')
    q.answer = Math.pow(base, pow + 1)
}


//Multiplier la puissance d'un nombre (positif) par le même nombre. Donner le résultat sous la forme d'un chiffre !
level.addQuestion({
    generator: function (q) {
        let base = random.fairChoice([3, 4, 5, 6, 7, 10])
        commonMultiplyWithPower(q, base, 1)
    }
})



level.addQuestion({
    generator: function (q) {
        let pow = random.fairChoiceInt(2, 4)
        commonMultiplyWithPower(q, 2, pow)
    }
})


function commonMultiplyPowers (q, base, pow1, pow2) {
    q.addMathFormula(base + '^\\color{blue}[' + pow1 + ']xx' + base + '^\\color{blue}[' + pow2 + ']')
    q.answer = Math.pow(base, pow1 + pow2)
}



//Multiplier deux puissances (même base 2). La puissance totale ne doit pas exceder 5
level.addQuestion({
    generator: function (q) {
        let base   = 2
        let powMax = 5
        let pow1   = random.fairChoiceInt(1, 4, {name: 'pow1'})
        let pow2   = random.fairChoiceInt(1, powMax - pow1, {name: 'pow2'})

        commonMultiplyPowers(q, base, pow1, pow2)
    },
    times: 2
})


function commonMultiplyPow (q, base) {
    let pow1 = random.fairChoiceInt(5, 10, {name: 'pow1'})
    let pow2 = random.fairChoiceInt(5, 10, {name: 'pow2'})

    q.addMathFormula(base + '^\\color{blue}[' + pow1 + ']xx' + base + '^\\color{blue}[' + pow2 + ']')
    q.addText('\n')
    q.addAnswerFormula(base + '^\\color{green}[?]')

    q.answer = pow1 + pow2
}


//Multiplier deux puissances (même base 2) - Résultat sous forme de puissance
level.addQuestion({
    generator: function (q) {
        commonMultiplyPow(q, 2)
    },
    errorExpected: true
})


//Multiplier deux puissances (base 3-9) - Résultat sous forme de puissance
level.addQuestion({
    generator: function (q) {
        let base = random.fairChoiceInt(3, 9)
        commonMultiplyPow(q, base)
    }
})


//Multiplier deux puissances (base -3 - -9) - Résultat sous forme de puissance
level.addQuestion({
    generator: function (q) {
        let base = -random.fairChoiceInt(3, 9)
        commonMultiplyPow(q, base)
    }
})


export default level
